// Event, Dialog
import EventBus from "@/event/EventBus";

//Lib 
import commonActionHandle from "@/commonActionHandle";

// Api
import api from '@/api/baseApi';

// Constant 
import { SETTINGS_RENTAL_API, SETTINGS_FIXED_RENTAL_API } from "@/constant/apiSettings";
import { API_CALL_STATUS } from "@/constant/baseConstant";
import { ELEMENT_LIST_PERIOD, FIXED_RENTAL_STATUS } from "@/constant/fixedRental";

// Extend
import base from '@/scripts/base';

// Component
import FixedRentalCampaignName from "@/views/component/FixedRental/FixedRentalCampaignName";
import FixedRentalDescription from "@/views/component/FixedRental/FixedRentalDescription";
import FixedRentalSettings from "@/views/component/FixedRental/FixedRentalSettings";
import InformationBasic from "@/views/component/RentalService/InformationBasic";
import NoMachineAvailable from "@/views/component/RentalService/Notification/NoMachineAvailable";
import BalanceNotEnough from "@/views/component/RentalService/Notification/BalanceNotEnough";
import LimitImage from "@/views/component/RentalService/Notification/LimitImage";
import MachineInShutdownState from "@/views/component/FixedRental/Notification/MachineInShutdownState";

export default {

    extends: base,

    components: {
        FixedRentalCampaignName,
        FixedRentalDescription,
        FixedRentalSettings,
        InformationBasic,
        NoMachineAvailable,
        BalanceNotEnough,
        LimitImage,
        MachineInShutdownState,
    },

    data() {
        return {
            listPeriod: ELEMENT_LIST_PERIOD,
        };
    },

    methods: {

        //#region Fixed rental create
        fixedRentalCreate(data, callBack) {
            api.baseRequest(SETTINGS_FIXED_RENTAL_API.FIXED_RENTAL_CREATE, data)
                .then((res) => {
                    switch (res.errorCode) {
                        case FIXED_RENTAL_STATUS.SUCCESS:
                            EventBus.$emit("processingEventRental", { event: "isLoadingElement", data: data.listMachineId });
                            EventBus.$emit("processingEventRental", { event: "autoRefresh" });
                            this.notificationSuccess('Rental Plan success !', 'Machine has been successfully fixed rent');
                            if (callBack) callBack();
                            break;
                        case FIXED_RENTAL_STATUS.BALANCE_NOT_ENOUGH:
                        case FIXED_RENTAL_STATUS.MACHINE_NOT_AVAILABLE:
                            setTimeout(() => {
                                this.isShowErrorInformation = true;
                            }, 500);
                            this.errorCode = res.errorCode
                            break;
                    }
                    this.feedStatusLoading(API_CALL_STATUS.SUCCESS);
                })
                .catch(error => {
                    this.processCatchApiRequest(error, "Rental Plan failed ...")
                });
        },
        //#endregion 

        //#region Rental request create
        baseRentalRequestCreate(data, machineEntity, callBack) {
            api.baseRequest(SETTINGS_RENTAL_API.RENTAL_REQUEST_CREATE, data)
                .then(() => {
                    EventBus.$emit("processingEventRental", { event: "autoRefresh" });
                    commonActionHandle.showCustomSuccess(
                        'Request success !',
                        `Your request has been sent successfully. Our system will send you an emal to notify you when ${machineEntity.packageName} is available`
                    );
                    if (callBack) callBack();
                    this.feedStatusLoading(API_CALL_STATUS.SUCCESS);
                })
                .catch(error => {
                    this.processCatchApiRequest(error, "Request failed ...")
                });
        },
        //#endregion
    },
}